module.exports = __webpack_public_path__ + "img/lost-banner.8aa88679.png";